import Icons from "../svg/Icons.ts";

/**
 * return files picked by User
 */
export async function pickFileFromDevice(accept :string,multiple = false) :Promise<File[]>{
  return new Promise((resolve,reject)=>{
    var input = document.createElement('input');
    input.type = 'file';
    if(multiple===true){
      input.multiple = true;
    }
    input.accept = accept;
    input.addEventListener('change', e => resolve(Array.from((e.target as HTMLInputElement).files)), {once: true});
    input.addEventListener('cancel', e => resolve([]), {once: true});
    input.click();
  })

}

//FIXME put this elsewhere
export function downloadUrl(url :string,fileName :string){
  var a = document.createElement('a')
  a.textContent = fileName;
  a.download = fileName
  a.href = url;
  a.click()
  return a;
}


type DropConsumer = ()=>Promise<{
  nodes:Iterable<HTMLElement>,
  ondrop:(
    this: HTMLElement,
    ev: DragEvent
  ) => any}>

const
  droppableFactories :DropConsumer[] = [];

export function registerFileDropConsumer(factory :DropConsumer){
  droppableFactories.push(factory)
}

function checkDragFile(event :DragEvent){
  if(event.dataTransfer.files.item.length===0) return;
  if(document.body.classList.contains('dragging')) return;

  event.preventDefault();
  document.body.classList.add('dragging');
  droppableFactories.forEach(async (factory)=>{
    var {nodes,ondrop} = await factory();
    Array.from(nodes).forEach(node=>{
      node.classList.add('droppable');
      node.addEventListener('dragover',(event)=>{
        event.preventDefault();
      })
      node.addEventListener('drop',function(event){
        event.preventDefault();
        document.body.classList.remove('dragging');
        ondrop.call(this,event)
      })
    })
  })
}
document.body.addEventListener("dragover",checkDragFile)
document.body.addEventListener("drop",function(event){
  event.preventDefault()
})

registerFileDropConsumer(async function(){
  var formsWithFile = Array.from(document.body.querySelectorAll('form')).filter(form=>form.querySelector('input[type="file"]'))
  return {
    nodes:formsWithFile,
    ondrop(this: HTMLElement,event :DragEvent){
      var inputFile = this.querySelector('input[type="file"]') as HTMLInputElement

      if(!acceptFiles(inputFile,event.dataTransfer.files)) return;

      inputFile.files = event.dataTransfer.files;
      inputFile.dispatchEvent(new Event("change"));
    }
  }
})
export function acceptFiles(inputFile :HTMLInputElement, files : FileList ) :boolean{
  const acceptPattern = inputFile.accept.split(',').map(type => type.trim());
  for(var file of Array.from(files)){
    const isAccepted = acceptPattern.some(type => {
      if (type.endsWith('/*')) {
        const baseType = type.slice(0, -1);
        return file.type.startsWith(baseType);
      } else {
        return file.type === type;
      }
    });
    if(!isAccepted) return false;
  }
  return true;
}

class DragError extends Error{};
/**
 * will apply the function to an element when starting to drag it
 * giving a dropPromiseBuilder that must be call with the potential drop target
 */
export function registerDragStart(selector : string,func : (this:HTMLElement,event:DragEvent,dropBuilder:typeof dropPromiseBuilder)=>void){
  document.body.addEventListener('dragstart',async function(event){
    var dragged = event.target as HTMLElement;
    if(dragged.matches && dragged.matches(selector)){
      try{
        await func.call(dragged,event, dropPromiseBuilder)
      }catch(e){
        if(e instanceof DragError){
          console.log(e.message)
        }else{
          throw e;
        }
      }
    }
  })

}
/**
 * Create a promise of drop of dragging in all dropTargets
 * It create/clean all event listener
 * @param dragging
 * @param dropTargets
 * @returns
 */
export async function dropPromiseBuilder(dragging :HTMLElement,dropTargets :HTMLElement[], excludeDropParent=true):Promise<DragEvent>{
  document.body.classList.add("dragging")

  //clean droptarget keeping only those who do not contains dragging
  if(excludeDropParent){
    dropTargets = dropTargets.filter(dropTarget=>!dropTarget.contains(dragging));
  }

  function prevent(this:HTMLElement, event:DragEvent){
    event.preventDefault();
  }
  //important must have css like .droppable>* : pointer-events: none;
  function enter(this:HTMLElement, event :DragEvent){
    this.classList.add('droppable-active')
  }
  function leave(this:HTMLElement, event :DragEvent){
    this.classList.remove('droppable-active')
  }



  var
    timeout :number;
  return new Promise<DragEvent>((resolve,reject)=>{
    document.body.addEventListener("dragend",()=>reject(new DragError("Drag aborted")))
    dropTargets.forEach(dropTarget=>{
      dropTarget.addEventListener("drop",resolve, {once:true})
      dropTarget.addEventListener("dragover",prevent)
      dropTarget.addEventListener("dragenter",enter)
      dropTarget.addEventListener("dragleave",leave)
      dropTarget.classList.add("droppable")
    })
    timeout = setTimeout(()=>reject(new DragError("Drag timeout done")),10000)

  }).finally(()=>{
    clearTimeout(timeout)
    dropTargets.forEach(dropTarget=>{
      dropTarget.removeEventListener("dragover",prevent)
      dropTarget.removeEventListener("dragenter",enter)
      dropTarget.removeEventListener("dragleave",leave)
      dropTarget.classList.remove("droppable")
      dropTarget.classList.remove("droppable-active")
    })
    document.body.classList.remove("dragging")

  })
}

export function getIconFromMimeType(mimeType : string){
  if(mimeType.indexOf('image')===0){
    return Icons.filer.ic_file_type_image;
  }else if(mimeType.indexOf('video')===0){
    return Icons.filer.ic_file_type_video;
  }else if(mimeType.indexOf('audio')===0){
    return Icons.filer.ic_file_type_sound;
  }else if(mimeType.indexOf('application/pdf')===0){
    return Icons.filer.ic_file_type_pdf;
  }else if(mimeType.indexOf('spreadsheet')>-1||mimeType.indexOf('ms-excel')>-1 ){
    return Icons.filer.ic_file_type_xls;
  }else if(mimeType.indexOf('presentation')>-1||mimeType.indexOf('ms-powerpoint')>-1 ){
    return Icons.filer.ic_file_type_ppt;
  }else if(mimeType.indexOf('document')>-1||mimeType.indexOf('msword')>-1 ){
    return Icons.filer.ic_file_type_doc;
  }else if(mimeType.indexOf('compressed')>-1||mimeType.indexOf('zip')>-1 ){
    return Icons.filer.ic_file_type_zip;
  }else{
    return Icons.filer.ic_file_type_other;
  }
}
export function getSmallIconFromMimeType(mimeType: string){
  if(mimeType.indexOf('image')===0){
    return Icons.filer.ic_file_type_image_small;
  }else if(mimeType.indexOf('video')===0){
    return Icons.filer.ic_file_type_video_small;
  }else if(mimeType.indexOf('audio')===0){
    return Icons.filer.ic_file_type_sound_small;
  }else if(mimeType.indexOf('application/pdf')===0){
    return Icons.filer.ic_file_type_pdf_small;
  }else if(mimeType.indexOf('spreadsheet')>-1||mimeType.indexOf('ms-excel')>-1 ){
    return Icons.filer.ic_file_type_xls_small;
  }else if(mimeType.indexOf('presentation')>-1||mimeType.indexOf('ms-powerpoint')>-1 ){
    return Icons.filer.ic_file_type_ppt_small;
  }else if(mimeType.indexOf('document')>-1||mimeType.indexOf('msword')>-1 ){
    return Icons.filer.ic_file_type_doc_small;
  }else if(mimeType.indexOf('compressed')>-1||mimeType.indexOf('zip')>-1 ){
    return Icons.filer.ic_file_type_zip_small;
  }else{
    return Icons.filer.ic_file_type_other_small;
  }
}

export function iconsimple(file :{mimeType?:string,type:string},css :string){
  var type = file.mimeType?file.mimeType:file.type;
  return `<icon style="${css}">${getSmallIconFromMimeType(type)}</icon>`
}